import useRead from '../useRead';

const useGetCertificate = ({ certificateId, onSuccess } = {}) => {
  const {
    data,
    paramsObject,
    setGetListParams,
  } = useRead({
    url: "certificate/view",
    initialData: certificateId ? { certificate_id: certificateId } : {},
    method: "GET",
    enabled: !!certificateId,
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
  });

  return {
    data,
    paramsObject,
    setGetListParams,
  };
};

export default useGetCertificate;
